const data = {
  id: 1,
  title: 'Listen and number',
  subTitle: 'Nghe và đánh số thứ tự nội dung xuất hiện trong bài',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/43fa6d39-99c8-4d99-ac8e-64e52f2b9b18.mp3',
  question: '',
  answers: [
    { answer: '1', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/table%20tennis.png' },
    { answer: '2', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/badminton.png' },
    { answer: '3', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/sport.png' },
  ],
};

export default data;
